import { Component, Input } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'label-extended-control',
    templateUrl: 'label-extended.control.html',
    standalone: false,
})
export class LabelExtendedControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    @Input() labelText!: string;
}
